import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IAuthSignInDto, IAuthSignInResponse } from "./types";

const postApis = createPostApi<
  IApiResponse<IAuthSignInResponse>,
  IPathBaseParam,
  IAuthSignInDto
>("auth.signIn");

export const signIn = {
  ...postApis,
};
